export const APOLLO_CACHE_SCRIPT_ID = "apollo-state";
export const APP_CTX_SCRIPT_ID = "app-ctx";
